(() => {
  'use strict';
  if (window.__NH2_PRODUCT_POLISH__) return;
  window.__NH2_PRODUCT_POLISH__ = true;

  const root = document.querySelector('[data-nh2-product-root]');
  const marker = root?.querySelector('[data-nh2-current-product]');
  if (!root || !marker?.dataset.nh2Handle) return;

  const normalize = (value) => String(value || '').trim().toLocaleLowerCase('pl-PL');
  const privateVendor = (value) => {
    const text = normalize(value);
    return !text || text.includes('topstoc') || text.includes('bysil') || text.includes('biokominkigmt') || text.includes('supplier') || text.includes('hurtown') || text.includes('wholesale') || text.includes('dostawc') || text.includes('noirhome');
  };

  const cleanMarketingNoise = () => {
    const description = root.querySelector('.nh2-description');
    if (!description) return;
    const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = String(node.nodeValue || '')
        .replace(/[⭐★🌟🔥✅✔🎁]/g, '')
        .replace(/\bDOSTAWA\s+GRATIS\b/gi, '')
        .replace(/\bHIT\b/g, '')
        .replace(/[ \t]{2,}/g, ' ');
    });
  };

  const applyIdentity = (product) => {
    const node = root.querySelector('.nh2-product-vendor[data-nh2-public-vendor]');
    if (!node || !product) return;
    const vendor = privateVendor(product.vendor) ? '' : String(product.vendor || '').trim();
    const type = String(product.type || '').trim();
    const label = vendor || type;
    if (label) {
      node.textContent = label;
      node.hidden = false;
    } else {
      node.textContent = '';
      node.hidden = true;
    }
  };

  const markGallery = () => {
    const gallery = root.querySelector('.nh2-gallery');
    if (!gallery) return;
    const count = gallery.querySelectorAll('.nh2-gallery-item').length;
    gallery.dataset.nh2MediaCount = String(count);
    gallery.classList.toggle('nh2-gallery--single', count === 1);
  };

  const run = async () => {
    cleanMarketingNoise();
    markGallery();
    try {
      const response = await fetch(`/products/${encodeURIComponent(marker.dataset.nh2Handle)}.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      applyIdentity(await response.json());
    } catch (_) {}
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once:true });
  else run();
  document.addEventListener('shopify:section:load', run);
})();